import {
  LF_TOGGLE_PENCIL_ACTIVATION,
  LF_TOGGLE_ERASER_ACTIVATION,
  LF_ERASE_ALL
} from '../action-types/doodle-stage';

const initialState = {
  pencilActive: false,
  eraserActive: false,
  eraseAll: 0
};

export default function doodleStage(state = initialState, action) {
  switch (action.type) {
    case LF_TOGGLE_PENCIL_ACTIVATION: {
      return Object.assign({}, state, {
        pencilActive: !state.pencilActive,
        eraserActive: false
      });
    }

    case LF_TOGGLE_ERASER_ACTIVATION: {
      return Object.assign({}, state, {
        eraserActive: !state.eraserActive,
        pencilActive: false
      });
    }

    case LF_ERASE_ALL: {
      return Object.assign({}, state, {
        eraseAll: state.eraseAll === 0 ? 1 : 0
      });
    }

    default: {
      return state;
    }
  }
}
